const initNumberingTechnicalSpecification = () => {
    const technicalSpecificationWidgetsArray = document.querySelectorAll(".technical-specifications-widget");
    if (technicalSpecificationWidgetsArray && technicalSpecificationWidgetsArray.length > 0) {
        technicalSpecificationWidgetsArray.forEach((technicalSpecification) => {
            const tabsTableArray = technicalSpecification.querySelectorAll(".tab-table");
            const infoTableContainersArray = technicalSpecification.querySelectorAll(".info-table-container");
            infoTableContainersArray.forEach((infoTableContainer) => {
                // NUMBERING INFO TABLE CONTAINER
                for (let i = 0; i < infoTableContainersArray.length; i++) {
                    infoTableContainersArray[i].setAttribute("data-number-info", i.toString());
                }
            });
            tabsTableArray.forEach((tabsTable) => {
                //NUMBERING TABS
                for (let j = 0; j < tabsTableArray.length; j++) {
                    tabsTableArray[j].setAttribute("data-number-tab", j.toString());
                }
                // CLICK BEHAVIOUR
                tabsTable.addEventListener("click", () => {
                    if (!tabsTable.classList.contains("active")) {
                        for (let k = 0; k < tabsTableArray.length; k++) {
                            tabsTableArray[k].classList.remove("active");
                        }
                        tabsTable.classList.add("active");
                        for (let z = 0; z < infoTableContainersArray.length; z++) {
                            infoTableContainersArray[z].classList.remove("active");
                            if (tabsTable.getAttribute("data-number-tab") == infoTableContainersArray[z].getAttribute("data-number-info")) {
                                infoTableContainersArray[z].classList.add("active");
                            }
                        }
                    }
                });
            });
        });
    }
};
